module.exports = __webpack_public_path__ + "static/media/motic challenge1.002a2890.png";